import { useState } from 'react';
export default function (initialState) {
  if (initialState === void 0) {
    initialState = false;
  }

  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var toggle = function toggle(newState) {
    if (newState !== undefined && newState !== state) {
      setState(newState);
    } else if (newState === undefined) {
      setState(!state);
    }
  };

  return [state, toggle];
}